import { Box } from '@mui/material';
import React from 'react'
import Colors from '../../Constant/Colors';
function Progress({ progress, size = "40" }) {
const angle = progress * 360;
  return (
    <Box
      sx={{
        background: `radial-gradient(${"white"} 55%, transparent 56%),
            conic-gradient(transparent 0deg ${angle}deg, ${Colors.secondary} ${angle}deg 360deg),
            ${Colors.primary}`,
        borderRadius: "50%",
        width: `${size}px`,
        height: `${size}px`,
      }} />
  )
}

export default Progress